import React, { useState, useEffect, useRef } from 'react';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { number, func } from 'prop-types';
import { Loading, TableCustom, WrapperAdvancedSearch, Modal } from '../../common';
import { getDateSerialize, getDateToString, getFormatNumber } from '../../../utils/convert';
import { useEntidad } from '../../hooks/useEntidad';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import CuentaDebitoCreditoPartidaGrid from '../CuentaDebitoCreditoPartidaGrid';
import {TIPS} from "../../../consts/tips";

const CuentaDebitosCreditosGrid = (props) => {

    const searchRef = useRef()

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        idTipoTributo: 0,
        numeroPartida: 0,
        showPartida: false
    });
    const [loading, setLoading] = useState(false);
    const [ items, setItems ] = useState([]);
    const [hasChanges, setHasChanges] = useState(false);

    const mount = () => {
        setState(prevState => {
            return {...prevState,
                idCuenta: props.idCuenta,
                idTipoTributo: props.idTipoTributo
            };
        });
    }
    useEffect(mount, [props.idCuenta]);

    // useEffect(() => {
    //     if (state.idCuenta > 0) {
    //         SearchPartidas();
    //     }
    //     else {
    //         setItems([]);
    //     }
    // }, [state.idCuenta]);

    const [, getRowEntidad] = useEntidad({
        entidades: ['Tasa','SubTasa', 'TipoCondicionEspecial'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        }
    });


    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setLoading(false);
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setLoading(false);
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setLoading(false);
    }
    const callbackSuccessSearchPartidas = (response) => {
        response.json()
        .then((data) => {
            setLoading(false);
            setItems(data);
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setLoading(false);
        });
    }

    function SearchPartidas() {

        const filters = searchRef.current.filters

        let paramsUrl = `/filter?idCuenta=${state.idCuenta}&soloTasaCabecera=true`;
        if (filters.idTasa > 0) paramsUrl += `&idTasa=${filters.idTasa}`;
        if (filters.idSubTasa > 0) paramsUrl += `&idSubTasa=${filters.idSubTasa}`;
        if (filters.numeroPartida > 0) paramsUrl += `&numeroPartida=${filters.numeroPartida}`;
        if (filters.fechaDesde) paramsUrl += `&fechaDesde=${encodeURIComponent(getDateSerialize(filters.fechaDesde))}`;
        if (filters.fechaHasta) paramsUrl += `&fechaHasta=${encodeURIComponent(getDateSerialize(filters.fechaHasta))}`;

        setLoading(true);

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            null,
            callbackSuccessSearchPartidas,
            callbackNoSuccess,
            callbackError
        );

    }


    const getDescTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? `${row.codigo}` : '';
    }
    const getDescSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }

    const handleClickPartidaView = (numeroPartida) => {
        setState(prevState => {
            return {...prevState, showPartida: true, numeroPartida: numeroPartida};
        });
    }

    const cellVMR = ({row}) =>  <div className='action'>
                                    <div onClick={ (event) => handleClickPartidaView(row.original.numeroPartida) } className="link">
                                        <span className="material-symbols-outlined" title="Modificar partida">stylus</span>
                                    </div>
                                </div>

    const tableColumns = [
        { Header: 'Partida', accessor: 'numeroPartida', width: '10%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Tasa', Cell: (props) => getDescTasa(props.value), accessor: 'idTasa', width: '10%', disableSortBy: true, ellipsis: false},
        { Header: 'Sub tasa', Cell: (props) => getDescSubTasa(props.value), accessor: 'idSubTasa', width: '20%', disableSortBy: true},
        { Header: 'Período', accessor: 'periodo', width: '10%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Cuota', accessor: 'cuota', width: '10%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Saldo pendiente', Cell: (props) => getFormatNumber(props.value, 2), id: 'importeSaldo', accessor: 'importeSaldo', width: '15%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Vto.', Cell: (props) => (props.value) ? getDateToString(props.value, false) : '', accessor: 'fechaVencimiento2', width: '10%', disableSortBy: true, ellipsis: false},
        { Header: '', Cell: cellVMR, id:'abm', accessor: 'index', width: '5%', disableGlobalFilter: true, disableSortBy: true, ellipsis: false}
    ];


    const onSearch = () => {
        SearchPartidas();
    }


    return (
    <>

        <Loading visible={loading}></Loading>

        <Modal
            size="xl"
            title="Débitos y créditos - Partidas"
            tipName={TIPS.NAME.MODALS.CUENTA_DEBITOS_CREDITOS_MODAL}
            onEscape={() => props.onClickVolver(hasChanges)}
            body={(
                <div className="row">

                    <WrapperAdvancedSearch
                        ref={searchRef}
                        onSearch={onSearch}
                        filters={[
                            { title: 'Partida', field: 'numeroPartida', type: 'string', size: 3 },
                            { title: 'Fecha desde', field: 'fechaDesde', type: 'date', size: 3 },
                            { title: 'Fecha hasta', field: 'fechaHasta', minValueField: 'fechaDesde', type: 'date', size: 3 },
                            { title: 'Tasa', field: 'idTasa', type: 'tasa', size: 6 },
                            { title: 'Sub tasa', field: 'idSubTasa', type: 'subtasa', fieldTasa: 'idTasa', size: 6 }
                        ]}
                    />

                    <TableCustom
                        showFilterGlobal={false}
                        className={'TableCustomBase'}
                        columns={tableColumns}
                        data={items}
                    />

                </div>
            )}
            footer={props.onClickVolver && (
                    <button className="btn back-button float-start" data-dismiss="modal" onClick={() => props.onClickVolver(hasChanges)}>Volver</button>
            )}
            footerClassName="modal-footer-unset"
        />

        {state.showPartida &&
            <CuentaDebitoCreditoPartidaGrid
                data={{
                    idCuenta: state.idCuenta,
                    idTipoTributo: state.idTipoTributo,
                    numeroPartida: state.numeroPartida
                }}
                onDismiss={(hasChanges) => {
                    setState(prevState => {
                        return {...prevState, showPartida: false, numeroPartida: 0};
                    });
                    if (hasChanges) {
                        setHasChanges(true);
                        SearchPartidas();
                    }
                }}
            />
        }

    </>
    );
}

CuentaDebitosCreditosGrid.propTypes = {
    idCuenta: number.isRequired,
    idTipoTributo: number.isRequired,
    onClickVolver: func.isRequired
};

export default CuentaDebitosCreditosGrid;